import { Box } from '@mui/material';
import React, { useContext } from 'react';
import { AuthContext } from 'src/context/AuthContext';
import sidebarlogo from '../logo/sidebarlogo/imagesidebar.png';
import config from 'src/config';

const HeaderLogo = () => {
  const { state } = useContext(AuthContext);
  const isLogin = state.isAuthenticated;
  let url = isLogin ? `${config.LIVE_URL}/dashboard/app` : `${config.LIVE_URL}/login`;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'start', pt: 2, pl: 2, mb: 5 }}>
      <a href={url} target="_blank" rel="noopener noreferrer">
        <img src={sidebarlogo} alt="Mevelsurvey Logo" style={{ maxWidth: '240px' }} />
      </a>
    </Box>
  );
};

export default HeaderLogo;
